export default __webpack_public_path__ + "static/medium-47dad125884b578b3dffd86a28fefc55.svg";